import { createFileRoute } from '@tanstack/react-router';
import { AboutPage } from '../../pages/AboutPage';
import { staticPageHead } from '../../lib/seo/staticPageHead';

export const Route = createFileRoute('/_site/about')({
  head: () =>
    staticPageHead({
      path: '/about',
      title: 'About AnyAPI - one wallet for the API economy',
      description:
        'Why we built a single key and a single USD wallet for third-party data, and how the routing and failover behind it work. Built by AnyAPI Labs, Inc.',
      og: { title: 'About AnyAPI' },
    }),
  component: AboutPage,
});
